var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownBanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 38,
    viewBox: "0 0 63 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 24.1805L56.0011 0L63 6.9122L31.5 38L0 6.9122L6.9989 0.00488692L31.5 24.1805Z",
    fill: "#D4B97B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownBanner);
export default __webpack_public_path__ + "static/media/arrow-down-banner.78ec83897e907574f5692bcb55acac70.svg";
export { ForwardRef as ReactComponent };